<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path fill-rule="evenodd"
      d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
      clip-rule="evenodd" />
  </svg>
</template>

<script setup lang="ts">
/**
 * ArrowLeftIcon component
 * 
 * @description Left arrow icon used for navigating to previous message alternatives
 * @example
 * <ArrowLeftIcon />
 */
</script>

<style scoped>
/* Icon inherits color from parent */
</style>
